export default __webpack_public_path__ + "img/47638413f4389304299ba2e4c13c444a.jpg";